import { CALL_API } from './api'
import { getAccessToken } from 'Lib'
// import types from '../types'
export default store => next => action => {
	
	const entry = action[CALL_API]
	// const ignorTypes  = [types.]
	if (typeof entry !== 'object') return next(action)

	let token
	const entryType = entry.types[0]

	if (entryType.startsWith("CORE")) {
		token = getAccessToken()
	}
	// else if(entry.types[0].startsWith("O365")){ 
	//   token = getAccessToken()
	// }
	
	if (!token) return next(action)
	
	entry.headers = { ...entry.headers }
	if (token) {
		entry.headers.Authorization = `Bearer ${token}`
	}

	next(action)
}


// WEBPACK FOOTER //
// ./src/middlewares/setToken.js